import { Routes, Route } from 'react-router-dom';
import PrivateRoutes from './PrivateRoutes';

import Principal from '../pages/Principal/principal';
import Login from '../pages/Login/login';
import DashboardPage from '../pages/DashboardPBI/dashboard_pbi';
//import Dashboard from '../pages/Dashboard/dashboard';
import GerarSenha from '../pages/GerarSenha/gerarsenha';
import Clientes from '../pages/Clientes/clientes';
import Desvios from '../pages/Desvios/desvios';
import CadastroDesvios from '../pages/CadastroDesvio/cadastrodesvio';
import Fluidos from '../pages/Fluidos/fluidos';
import CadastroFluidos from '../pages/CadastroFluido/cadastrofluido';
import Equipamentos from '../pages/Equipamentos/equipamentos';
import CadastroEquipamentos from '../pages/CadastroEquipamento/cadastroequipamento';
import Compartimentos from '../pages/Compartimentos/compartimentos';
import CadastroCompartimentos from '../pages/CadastroCompartimento/cadastrocompartimento';
import OrdemManutencao from '../pages/OrdemManutencao/ordemmanutencao';
import CadastroOrdens from '../pages/CadastroOrdem/cadastroordem';
import CadastroAnalises from '../pages/CadastroAnalise/cadastroanalises';
import DocumentoAprovacao from '../pages/CadastroDocAprovacao/cadastrodocaprovacao';

import Relatorios from '../pages/Relatorios/relatorios';
import UploadZip from '../pages/UploadZip/uploadzip';

export default function Routeses() {
  return(
    <div>
      <Routes>
            <Route element={<PrivateRoutes />}>
            <Route element={<Principal />} path="/principal" />
            <Route element={<DashboardPage />} path="/dashboard" />
            <Route element={<Clientes />} path="/clientes" />
            <Route element={<GerarSenha />} path="/gerarsenha" />

            <Route element={<Desvios />} path="/desvios" />
            <Route element={<CadastroDesvios funcao={'Inclusão'}/>} path="/desvios/inclusao" />
            <Route element={<CadastroDesvios funcao={'Alteração'}/>} path="/desvios/alteracao/:codigo" />
            <Route element={<CadastroDesvios funcao={'Consulta'}/>} path="/desvios/consulta/:codigo" />
            <Route element={<CadastroDesvios funcao={'Exclusão'}/>} path="/desvios/exclusao/:codigo" />

            <Route element={<Fluidos />} path="/fluidos" />
            <Route element={<CadastroFluidos funcao={'Inclusão'}/>} path="/fluidos/inclusao" />
            <Route element={<CadastroFluidos funcao={'Alteração'}/>} path="/fluidos/alteracao/:codigo" />
            <Route element={<CadastroFluidos funcao={'Consulta'}/>} path="/fluidos/consulta/:codigo" />
            <Route element={<CadastroFluidos funcao={'Exclusão'}/>} path="/fluidos/exclusao/:codigo" />

            <Route element={<Equipamentos />} path="/equipamentos" />
            <Route element={<CadastroEquipamentos funcao={'Inclusão'}/>} path="/equipamentos/inclusao" />
            <Route element={<CadastroEquipamentos funcao={'Alteração'}/>} path="/equipamentos/alteracao/:codigo" />
            <Route element={<CadastroEquipamentos funcao={'Consulta'}/>} path="/equipamentos/consulta/:codigo" />
            <Route element={<CadastroEquipamentos funcao={'Exclusão'}/>} path="/equipamentos/exclusao/:codigo" />

            <Route element={<Compartimentos />} path="/compartimentos" />
            <Route element={<Compartimentos funcao={'Retorno'}/>} path="/compartimentos/:equipamentoId" />
            <Route element={<CadastroCompartimentos funcao={'Inclusão'}/>} path="/compartimentos/inclusao/:nomeEquipamento/:equipamentoId" />
            <Route element={<CadastroCompartimentos funcao={'Alteração'}/>} path="/compartimentos/alteracao/:nomeEquipamento/:equipamentoId/:compartimentoId" />
            <Route element={<CadastroCompartimentos funcao={'Consulta'}/>} path="/compartimentos/consulta/:nomeEquipamento/:equipamentoId/:compartimentoId" />
            <Route element={<CadastroCompartimentos funcao={'Exclusão'}/>} path="/compartimentos/exclusao/:nomeEquipamento/:equipamentoId/:compartimentoId" />

            <Route element={<OrdemManutencao />} path="/ordens" />             
            <Route element={<CadastroOrdens funcao={'Inclusão'}/>} path="/ordens/inclusao" />
            <Route element={<CadastroOrdens funcao={'Alteração'}/>} path="/ordens/alteracao/:ordemId" />
            <Route element={<CadastroOrdens funcao={'Consulta'}/>} path="/ordens/consulta/:ordemId" />
            <Route element={<CadastroOrdens funcao={'Exclusão'}/>} path="/ordens/exclusao/:ordemId" />
 
            <Route element={<CadastroAnalises />} path="/analises" />             
            <Route element={<CadastroAnalises funcao={'Inclusão'}/>} path="/analises/inclusao/:numero/:ordemId/:nomeEquipamento/:equipamentoId/:datainicialOM/:datafinalOM" />
            <Route element={<CadastroAnalises funcao={'Alteração'}/>} path="/analises/alteracao/:numero/:ordemId/:nomeEquipamento/:equipamentoId/:codigoCompartimento/:datainicialOM/:datafinalOM" />
            <Route element={<CadastroAnalises funcao={'Exclusão'}/>} path="/analises/exclusao/:numero/:ordemId/:nomeEquipamento/:equipamentoId/:codigoCompartimento/:datainicialOM/:datafinalOM/:datainclusaoOM" />
                                                                           
            <Route element={<DocumentoAprovacao />} path="/docaprovacao" />             
            <Route element={<DocumentoAprovacao funcao={'Inclusão'}/>} path="/docaprovacao/inclusao/:numero/:ordemId/:nomeEquipamento/:equipamentoId" />
            <Route element={<DocumentoAprovacao funcao={'Alteração'}/>} path="/docaprovacao/alteracao/:numero/:ordemId/:nomeEquipamento/:equipamentoId/:idtDocAprovacao" />
            <Route element={<DocumentoAprovacao funcao={'Exclusão'}/>} path="/docaprovacao/exclusao/:numero/:ordemId/:nomeEquipamento/:equipamentoId/:idtDocAprovacao" />

            {/* <Route element={<DocumentoAprovacao funcao={'Consulta'}/>} path="/docaprovacao/consulta/:numero/:ordemId/:nomeEquipamento/:equipamentoId/:idtDocAprovacao" /> */}
                                                                           
            <Route element={<UploadZip />} path="/uploadzip" />
            <Route element={<Relatorios />} path="/relatorios" />
            {/* <Route path="*" element={<NotFound />} /> */}

          </Route>


          <Route exact path="/" element={ <Login />} />
      </Routes>
    </div>
  )
}